import React, { useEffect, useState } from 'react';
import IconButtonWrapper from 'views/pages/manage/common/form-fields-mui/IconButtonWrapper';
import { ReactComponent as BackIcon } from "../../../../assets/img/svg/BackArrow.svg"
import ALoader from 'views/pages/manage/common/a-loader';
import { getStudentDetails } from 'views/pages/manage/unAssigned/collectPayment/apis';
import { useLocation } from "react-router";
import StudentRefundDetails from './StudentRefundDetails';
import styles from "../../refundStyles.module.scss";
import { getDropdowns } from './constants';
import { fetchAllBatchesByApplicationId } from 'redux/studentSearch/actions';
import { buildStudentDetails } from 'modules/studentRefund/common/services';
import { fetchStudentSecurityCourseId } from 'modules/studentRefund/studentRefundRequest/multiTypeRefund/utils';

const ReinitiateRefund = () => {
    const [details, setDetails] = useState({});
    const [loader, setLoader] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const psid = queryParams.get("psid");
    const applicationId = queryParams.get("applicationId");
    const refundAmount = queryParams.get("refundAmount");
    const refundNumber = queryParams.get("refundNumber");
    const orderType = queryParams.get("orderType");
    const subOrderType = queryParams.get("subOrderType");
    const [dropdownData, setDropdownData] = useState([]);

    const init = async () => {
        if (!psid) return;

        setLoader(true);
        try {
            const [dropdowns, sdCourseId, studentDetails, batchDetails] = await Promise.all([
                getDropdowns(),
                fetchStudentSecurityCourseId(applicationId),
                getStudentDetails(applicationId),
                fetchAllBatchesByApplicationId(applicationId),
            ]);

            setDropdownData(dropdowns);

            const formattedDetails = buildStudentDetails(studentDetails, dropdowns, {
                refundAmount,
                refundNumber,
                orderType,
                subOrderType,
                sdCourseId: sdCourseId,
                batchList: batchDetails?.map((item) => item?.batchName),
            });

            setDetails(formattedDetails);
        } catch (e) {
            console.error("Error initializing refund data:", e);
        } finally {
            setLoader(false);
        }
    };


    useEffect(() => {
        init();
    }, [psid]);

    return (<>
        {loader && <ALoader position="fixed" />}
        <div className="large-text mx-4 my-4 label-color d-flex align-items-center">
            <IconButtonWrapper onClick={() => window.close()}>
                <BackIcon />
            </IconButtonWrapper>
            {`${details?.studentName} (${psid})`}
            <div className={styles['reinit-refund-right-card']}>
                <div className={styles['leftText']}>Refund Type</div>
                <div className={styles['rightText']}>{orderType}</div>
            </div>
        </div>
        <div className='d-flex mx-4'>
            <div style={{ width: "100%", paddingBottom: "100px" }}>
                <StudentRefundDetails details={details} setLoader={setLoader} loader={loader} dropdownData={dropdownData} />
            </div>
        </div>
    </>)

}

export default ReinitiateRefund;
